// Shared Plaid configuration for resources and UI copy
// Centralizes bank vs payroll differences to avoid drift across components.

export type PlaidWorkflowType = 'bank' | 'payroll';

export const plaidResources = {
  bank: {
    linkTokenResource: 'plaidBankIncomeLinkToken',
    linkSuccessResource: 'plaidBankIncome',
    notifyLaunch: 'Plaid launching...',
    notifySuccess: 'Bank income retrieved.',
    notifyError:
      'Something went wrong while trying to connect to your bank. Please try again later.',
  },
  payroll: {
    linkTokenResource: 'plaidPayrollIncomeLinkToken',
    linkSuccessResource: 'plaidPayrollIncomePending',
    notifyLaunch: 'Plaid launching...',
    notifySuccess:
      'Payroll income is processing. Updates will appear shortly.',
    notifyError:
      'Something went wrong while trying to connect to your payroll provider. Please try again later.',
  },
} as const;

export const plaidCopy = {
  bank: {
    plaidActionDescription:
      'You can verify your income by securely connecting to your bank and sharing deposit information. If you continue, you’ll be redirected to link your bank account using your login credentials. Docuverus never sees nor stores your bank login information.',
    plaidActionWarning:
      'This action cannot be undone and may increase or decrease your average monthly net income calculation. You can upload payroll or bank documents instead, and you can still add documents after connecting.',
    plaidActionRelinkWarning:
      'Note: Re-linking the same institution replaces its current income sources and transactions with new deposit data.',
  },
  payroll: {
    plaidActionDescription:
      'You can verify your income by securely connecting to your payroll provider. If you continue, you’ll be redirected to link to your employer\'s payroll provider using your login credentials. Docuverus never sees nor stores your payroll login information.',
    plaidActionWarning:
      'This action cannot be undone and may increase or decrease your average monthly net income calculation. You can upload payroll or bank documents instead, and you can still add documents after connecting.',
    plaidActionRelinkWarning:
      'Note: Re-linking the same institution replaces its current payroll data with up-to-date information.',
  },
} as const;
